import {useEffect, useState} from "react";
import {useSnackbar} from "notistack";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import {useDeleteCarRentalMutation} from "../../../services/authService";
import ConfirmDialog from "../../ConfirmDialog";
import messages from "../../../utils/messages";
import styles from "../showName/DeleteShowName.module.scss";

const DeleteCarRental = ({ carRental, setCarRental, onDelete }) => {
    const [deleteCarRental, { isSuccess, error, reset }] = useDeleteCarRentalMutation();
    const { enqueueSnackbar } = useSnackbar();

    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    }

    const handleDelete = () => {
        deleteCarRental(carRental.id);
    }

    const handleMessages = () => {
        if(isSuccess){
            enqueueSnackbar(`${messages.success.deleteCarRental}`, { variant: 'success' });
            reset();
            onDelete();
            setCarRental(null);
        }
        if(error){
            enqueueSnackbar(`${messages.error.prefix} ${error?.data[0]?.errorMessage}`, { variant: 'error' });
        }
    }

    useEffect(() => {
        if(isSuccess || error){
            handleMessages();
        }
        // eslint-disable-next-line
    }, [isSuccess, error]);

    return (
        <>
            <DeleteOutlinedIcon
                fontSize="small"
                onClick={handleOpen}
                className={`${styles.icon} m-1`}
            />
            <ConfirmDialog
                title="Delete car rental"
                open={open}
                setOpen={setOpen}
                onConfirm={handleDelete}
            >
                {messages.confirm.deleteCarRental}
            </ConfirmDialog>
        </>
    )
}

export default DeleteCarRental;
